import React, { useEffect, useState } from 'react';
import Swal from '../../utils/darkSwal';
import { getUser } from '../../utils/authStorage';
import BASE_URL from '../../utils/api';
import PageHeading from '../PageHeading';
import Div from '../Div';
import Spacing from '../Spacing';


export default function AllOrders() {
  const [orders, setOrders] = useState([]);
  const user = getUser();
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (user && token) {
      fetchOrders();
    }
  }, [user, token]);

  const fetchOrders = async () => {
    try {
      const res = await fetch(`${BASE_URL}/api/orders/user/${user._id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setOrders(data);
    } catch (error) {
      Swal.fire('Error', 'Failed to load orders', 'error');
    }
  };

  return (
    <>
      <PageHeading title="My Orders" bgSrc="/images/portfolio_hero_bg.jpeg" pageLinkText="Orders" />
      <Spacing lg="80" md="60" />
      <Div className="user-orders-page container">
        <h3 className="user-orders-title">Order History</h3>
        {/* Recent Order Card */}
        <div className="user-orders-recent-wrapper">
          {orders.length > 0 ? (
            <div className="user-orders-recent-card">
              <div className="user-orders-recent-header">
                <span className="user-orders-recent-label">Recent Order</span>
                <span className={`user-orders-recent-status status-${orders[0].status.toLowerCase()}`}>
                  {orders[0].status}
                </span>
              </div>
              <div className="user-orders-recent-body">
                <h4>{orders[0].product.productName}</h4>
                <div className="user-orders-recent-details">
                  <span>Qty: <strong>{orders[0].quantity}</strong></span>
                  <span>Rs. {orders[0].purchasePrice.$numberDecimal}</span>
                </div>
                <div className="user-orders-recent-meta">
                  <span>{new Date(orders[0].createdAt).toLocaleString()}</span>
                  <span>Order ID: {orders[0]._id.slice(-6)}</span>
                </div>
              </div>
            </div>
          ) : (
            <div className="user-orders-recent-card user-orders-recent-empty">
              <span>No recent orders</span>
            </div>
          )}
        </div>

        {/* Desktop Table */}
        <div className="user-orders-table-wrapper">
          <table className="user-orders-table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Qty</th>
                <th>Price</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order._id}>
                  <td>{order.product.productName}</td>
                  <td>{order.quantity}</td>
                  <td>Rs. {order.purchasePrice.$numberDecimal}</td>
                  <td>{order.status}</td>
                  <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="user-orders-card-wrapper">
          {orders.map((order) => (
            <div className="user-orders-card" key={order._id}>
              <h4>{order.product.productName}</h4>
              <div className="user-orders-card-row">
                <span><strong>Qty:</strong> {order.quantity}</span>
                <span>Rs. {order.purchasePrice.$numberDecimal}</span>
              </div>
              <div className={`user-orders-card-status ${order.status.toLowerCase()}`}>
                {order.status}
              </div>
              <div className="user-orders-card-date">
                {new Date(order.createdAt).toLocaleString()}
              </div>
              <div className="user-orders-card-id">
                Order ID: {order._id.slice(-6)}
              </div>
            </div>
          ))}
        </div>
      </Div>
      <Spacing lg="80" md="60" />
    </>
  );
}
